
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';

import { imgHost, host } from "@/utils/config";
import axios from 'axios';

import {
    activityPersonalPKRankingMemberPhysicalPrizeList,
    memberPhysicalPrizeRankChangeList,
    memberPhysicalPrizeSendImport,
    memberPhysicalPrizeUpdate,
    memberPhysicalPrizeInvalid
} from '@/api/toBApi';

@Component({
    name: '',
    components: {
        PageFooter,
        PickerDate,
        'slz-dialog': Dialog,
    }
})
export default class PersonalPKRankingMemberPhysicalPrizeList extends Vue {

    private list = [];
    private keywords = '';
    private state = null;
    private pageNo = 1;
    private pageSize = 20;
    private total = 0;
    private loading = false;

    private uploadFileApi = host + '/api/file/upload?PlatForm=routuan&Path=File';

    private stateList = [
        { value: null, label: '全部' },
        { value: 0, label: '待领取' },
        { value: 1, label: '已领取，待发货' },
        { value: 2, label: '已发货' },
        { value: 3, label: '已失效' }
    ];

    private name = this.$route.query.name;
    private id = this.$route.query.id;


    private changeDetails = {
        show: false,
        pageNo: 1,
        pageSize: 20,
        list: [],
        total: 0,
        keywords: '',
        id: '',
        details: {}
    }

    private exportPop = {
        show: false,
        ExcelFilePath: '',
        ExcelFileName: '',
        loading: false,
        recordId: ''
    }


    private mounted() {
        this.doSearch();
    }

    private doSearch() {
        this.pageNo = 1
        this.getList()
    }
    private changePage(e) {
        this.pageNo = e
        this.getList()
    }
    private async getList() {
        this.loading = true;
        try {
            let params = {
                ActivityPersonalPKRankingId: this.id,
                Keywords: this.keywords.trim(),
                State: this.state,
                Skip: (this.pageNo - 1) * this.pageSize,
                Take: this.pageSize
            }
            const res: any = await activityPersonalPKRankingMemberPhysicalPrizeList(params);
            this.list = res.Result.Results;
            this.total = res.Result.Total;

        } catch (error) {

        } finally {
            this.loading = false;
        }
    }


    private handleEditState(type, record) {

        let title = '';
        if (type === 1) {
            title = `是否确认将分销员【${record.Name}】的奖励修改为第${record.NewRankNum}名的奖励？`;
        } else if (type === 2) {
            title = `是否确认失效分销员【${record.Name}】的奖励？`;
        }

        this.$confirm(title, '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确认',
            type: 'warning'
        }).then(async () => {
            if (type === 1) {
                await memberPhysicalPrizeUpdate({ ActivityPersonalPKRankingId: this.id, MemberPhysicalPrizeId: record.MemberPhysicalPrizeId, MemberId: record.MemberId })
                this.$message.success('操作成功');
                this.changeDetails.list.map(item => {
                    if (item.MemberPhysicalPrizeId === record.MemberPhysicalPrizeId) {
                        item.State = 3;
                    }
                    return item;
                })
            } else if (type === 2) {
                await memberPhysicalPrizeInvalid({ ActivityPersonalPKRankingId: this.id, MemberPhysicalPrizeId: record.MemberPhysicalPrizeId, MemberId: record.MemberId })
                this.$message.success('操作成功');
                this.changeDetails.list.map(item => {
                    if (item.MemberPhysicalPrizeId === record.MemberPhysicalPrizeId) {
                        item.State = 4;
                    }
                    return item;
                })
            }
        }).catch((e) => {
        });
    }

    //名次变更分销员
    private async handleShowChangePop() {
        
        this.changeDetails.pageNo = 1;
        try {
            let params: any = {
                Skip: (this.changeDetails.pageNo - 1) * this.changeDetails.pageSize,
                Take: this.changeDetails.pageSize,
                ActivityPersonalPKRankingId: this.id,
            }
            const res: any = await memberPhysicalPrizeRankChangeList(params);
            this.changeDetails.show = true;
            this.handlechangeDetailsPopSearch();
        } catch (e) {

        }
    }
    private handlechangeDetailsPopSearch() {
        this.changeDetails.pageNo = 1;
        this.getchangeDetails();
    }
    private changeDetailsChangePage(e) {
        this.changeDetails.pageNo = e;
        this.getchangeDetails();
    }
    private async getchangeDetails() {
        try {
            let params: any = {
                Skip: (this.changeDetails.pageNo - 1) * this.changeDetails.pageSize,
                Take: this.changeDetails.pageSize,
                ActivityPersonalPKRankingId: this.id,
            }
            const res: any = await memberPhysicalPrizeRankChangeList(params);
            let obj = res.Result;
            this.changeDetails.total = obj.Total;
            this.changeDetails.list = obj.Results;
        } catch (e) {

        }
    }

    private handleExportCommand(e) {
        if (e === 2) {
            this.exportRecords();
        } else if (e === 1) {
            this.exportPop.show = true;
            this.exportPop.ExcelFileName = '';
            this.exportPop.ExcelFilePath = '';
        }
    }
    private exportRecords() {
        let params: any = {
            ActivityPersonalPKRankingId: this.id,
            Keywords: this.keywords.trim(),
            State: this.state === null ? '' : this.state
        }

        const urls = Object.entries(params).map(item => {
            return `${item[0]}=${item[1]}`;
        })

        const url = `${window.origin}/pc/activityPersonalPKRanking/memberPhysicalPrizeList?${urls.join('&')}`;
        console.log(url)
        window.open(url);
    }

    //上传文件
    private beforeUploadExcel(e) {
        let fileTyle = e.name.split('.').pop();
        if (!['xls', 'xlsx'].includes(fileTyle.toLowerCase())) {
            this.$message.error('请上传正确格式的文件');
            return;
        }
        
        this.exportPop.ExcelFileName = e.name;
    }
    private handleUploadExcelSuccess(e) {
        this.exportPop.ExcelFilePath = e.Result[0];
        
    }
    private async sureUpload() {
        this.exportPop.loading = true;
        try {
            const res: any = await memberPhysicalPrizeSendImport({...this.exportPop, ActivityPersonalPKRankingId: this.id});

            const {
				RecordId,
			} = res.Result;

            this.getResult(RecordId);
        } catch (e) {
            this.exportPop.loading = false;
        } finally {
            
        }
    }
    private async getResult(RecordId){
        try {
			let res: any = await axios.get(`/pc/activityPersonalPKRanking/memberPhysicalPrizeSendImportResultExport?RecordId=${RecordId}&IsExport=false`, {
				responseType: undefined,
			})
            if (res.data.IsSuccess) {
                if (!res.data.Result.IsDealFinish) {
                    setTimeout(() => {
                        this.getResult(RecordId)
                    }, 500)
                } else {
                    this.exportPop.loading = false;
                    const {
                        SuccessCount, FailCount
                    } = res.data.Result;
                    this.$confirm(`导入完成，已成功导入${SuccessCount}条，失败${FailCount}条。`, '提示', {
                        showConfirmButton: false,
                        cancelButtonText: FailCount ? '下载失败数据' : '好的',
                        type: 'warning',
                        distinguishCancelAndClose: true
                    }).then(() => {
                    }).catch((e) => {
                        if (FailCount && 'cancel' === e) {
                            let url = `${location.origin}/pc/activityPersonalPKRanking/memberPhysicalPrizeSendImportResultExport?RecordId=${RecordId}&IsExport=true`;
                            window.open(url)
                        }
                    });
                }
            } else {
                this.exportPop.loading = false;
                this.$message.error(res.data.Message)
            }
		} catch (e) {
            this.exportPop.loading = false;
        } finally {
			//
		}
    }

    private openDownload(url){
		window.open(url)
	}

}
